import { useEffect } from 'react';

/**
 * Hook for monitoring component performance
 * @param componentName - Name of the component to monitor
 * @param additionalChecks - Optional function to run additional performance checks
 */
export const usePerformanceMonitoring = (
  componentName: string,
  additionalChecks?: () => void
) => {
  useEffect(() => {
    const mountTime = performance.now();
    console.log(`PERF:${componentName}: Component mounted at ${new Date().toISOString()}`);
    
    // Run any additional performance checks
    if (additionalChecks) {
      additionalChecks();
    }
    
    // Create a performance observer to monitor long tasks
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            console.log(`PERF:${componentName}: Long task detected: ${entry.duration.toFixed(2)}ms`);
          });
        });
        
        observer.observe({ entryTypes: ['longtask'] });
        
        return () => {
          observer.disconnect();
        };
      } catch (e) {
        console.error('PerformanceObserver error:', e);
      }
    }
  }, [componentName, additionalChecks]);
};